import styled, { css } from 'styled-components';

import { colors } from '../../styles/tokens';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
  isChecked: boolean;
}

export const ContainerInput = styled.label`
  background-color: transparent;
`;

export const Input = styled.input<ContainerProps>`
  width: 20px;
  height: 20px;
  vertical-align: middle;
  -webkit-appearance: none;
  background: none;
  flex-grow: 0;
  border-radius: 50%;
  background-color: ${colors.surfaceContainerHigh};
  transition: background 300ms;
  cursor: pointer;

  border: 1px solid ${colors.primary};

  ${props =>
    props.isErrored &&
    css`
      border-color: ${colors.error};
    `}

  &::before {
    content: '';
    color: transparent;
    display: block;
    width: inherit;
    height: inherit;
    border-radius: inherit;
    border: none;
    background-color: transparent;
    background-size: contain;
  }

  &:checked {
    background-color: ${colors.primary};
  }

  &:checked::before {
    display: none;
  }

  &:disabled {
    background-color: ${colors.surfaceContainerHighest};
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
